import { ROOT_CONTEXT, type Context } from '@opentelemetry/api';
import { StackContextManager } from '@opentelemetry/sdk-trace-web';

let navigationContext: Context | null = null;

/** Set while a page load is in progress; null between page loads. */
export const setNavigationContext = (context: Context | null): void => {
    navigationContext = context;
};

/**
 * StackContextManager only carries context across *synchronous* code, so in an SPA
 * nearly every span (component setup, TanStack queries, RES calls) starts parentless
 * and becomes its own root trace. Falling back to the current page's context makes
 * those spans children of the navigation that caused them.
 */
export class NavigationContextManager extends StackContextManager {
    public active(): Context {
        const active = super.active();
        if (active === ROOT_CONTEXT && navigationContext != null) return navigationContext;
        return active;
    }
}
